<div class="container container-shadow">
  <h4 class="pt-4">New Oral Deposition</h4>
  <hr />
  <div class="py-5 my-5 text-center" *ngIf="loading">
    <i class="fas fa-spinner fa-fw fa-pulse fa-5x"></i>
  </div>
  <h6 class="pb-3" *ngIf="formOptions.matter_number && !loading">
    <a [routerLink]="'/matters/' + matter_id"> {{ formOptions.matter_number }} - {{ formOptions.matter_name }} </a>
  </h6>
  <div class="alert alert-danger" *ngIf="formOptions.errors && !loading">
    <h6>Please correct the following errors in this matter before proceeding. Refresh this page once the errors have been corrected.</h6>
    <ul>
      <li *ngFor="let error of formOptions.errors">
        {{ error }}
      </li>
    </ul>
  </div>
  <form #currentForm="ngForm" *ngIf="!formOptions.errors && !loading">
    <div class="row mt-2">
      <div class="col-sm-6">
        <label>Deponent</label>
        <select (change)="oralDeposition.address_id = null; loadDepositionAddresses()" name="deponent_id" class="form-control" required [(ngModel)]="oralDeposition.deponent_id" [ngClass]="{ 'is-invalid': formSubmitted && !oralDeposition.deponent_id }">
          <option *ngFor="let deponent of formOptions.deponents" [value]="deponent.value">
            {{ deponent.label }}
          </option>
        </select>
        <small class="text-muted form-text">Only clients with deposition addresses marked for this matter</small>
        <div class="invalid-feedback">Deponent needs to be selected</div>
      </div>
      <div class="col-sm-6">
        <label>Deposition Address</label>
        <select class="form-control" required name="address_id" [disabled]="!oralDeposition.deponent_id || loadingDepositionAddresses" [(ngModel)]="oralDeposition.address_id" [ngClass]="{ 'is-invalid': formSubmitted && !oralDeposition.address_id }">
          <option *ngFor="let address of depositionAddresses" [value]="address.value">
            {{ address.label }}
          </option>
        </select>
        <div class="invalid-feedback">Deposition Address needs to be selected</div>
        <small class="text-muted form-text" *ngIf="!oralDeposition.deponent_id">Deposition Address can be listed after selecting deponent</small>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-sm-6">
        <label>Judge</label>
        <select name="judge_id" class="form-control" required [(ngModel)]="oralDeposition.judge_id" [ngClass]="{ 'is-invalid': formSubmitted && !oralDeposition.judge_id }">
          <option *ngFor="let judge of formOptions.judges" [value]="judge.value">
            {{ judge.label }}
          </option>
        </select>
        <div class="invalid-feedback">Judge needs to be selected</div>
      </div>
      <div class="col-sm-6">
        <label>Schedule by Date</label>
        <app-datepicker [date]="oralDeposition.schedule_by" (date_result)="oralDeposition.schedule_by = $event" [isInvalid]="formSubmitted && !oralDeposition.schedule_by"></app-datepicker>
        <div class="invalid-feedback">Schedule by date needs to be selected</div>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-sm-6">
        <label>Stenographer</label>
        <select name="stenographer_id" class="form-control" required [(ngModel)]="oralDeposition.stenographer_id" [ngClass]="{ 'is-invalid': formSubmitted && !oralDeposition.stenographer_id }">
          <option *ngFor="let stenographer of formOptions.stenographers" [value]="stenographer.value">
            {{ stenographer.label }}
          </option>
        </select>
        <div class="invalid-feedback">Stenographer needs to be selected</div>
      </div>
      <div class="col-sm-6">
        <label>Fee</label>
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text">$</span>
          </div>
          <input [(ngModel)]="oralDeposition.fee" type="number" class="form-control" placeholder="Fee" aria-label="Fee" name="fee" />
        </div>
      </div>
    </div>
    <div class="row mt-2"></div>
    <div class="row mt-2">
      <div class="col">
        <div class="card mb-1" [ngClass]="{ 'border-danger': formSubmitted && participantCount < 1 }">
          <div class="card-header">Participants<span class="text-danger" *ngIf="formSubmitted && participantCount < 1">&nbsp;- Atleast one selection is needed</span></div>
          <div class="card-body limited-height-extra-short">
            <div class="custom-controls-stacked">
              <div *ngFor="let participant of formOptions.participants" (click)="participant.checked = !participant.checked; updateParticipantCount()" class="custom-control custom-checkbox">
                <input type="checkbox" [checked]="participant.checked" [name]="'participant-' + participant.value" [(ngModel)]="participant.checked" class="custom-control-input" />
                <label class="custom-control-label">{{ participant.label }}</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col">
        <label>Notes</label>
        <textarea class="form-control" name="notes" [(ngModel)]="oralDeposition.notes"></textarea>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col text-center">
        <button type="button" (click)="saveOralDeposition(currentForm.form.valid)" [disabled]="formSubmitting" class="btn btn-primary">
          {{ formSubmitting ? 'Creating' : 'Create' }}<span *ngIf="formSubmitting">&nbsp;<i class="fas fa-spinner fa-fw fa-pulse"></i></span>
        </button>
        &nbsp;
        <button type="button" (click)="back()" [disabled]="formSubmitting" class="btn btn-outline-secondary">Cancel</button>
      </div>
    </div>
  </form>
  <div class="py-3"></div>
</div>
